import { useEffect, useSyncExternalStore } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AccountMenu } from '@/ui/profile';

export const Route = createFileRoute('/profile/')({
  component: ProfileIndexPage,
});

const DESKTOP_MQ = '(min-width: 1024px)';

function subscribeDesktop(onChange: () => void) {
  const mq = window.matchMedia(DESKTOP_MQ);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}

function getDesktopSnapshot() {
  return window.matchMedia(DESKTOP_MQ).matches;
}

function getServerSnapshot() {
  return false;
}

function useIsDesktopLg() {
  return useSyncExternalStore(subscribeDesktop, getDesktopSnapshot, getServerSnapshot);
}

/** Mobile: account menu. Desktop: redirect to Details (Figma default). */
function ProfileIndexPage() {
  const navigate = useNavigate();
  const isDesktop = useIsDesktopLg();

  useEffect(() => {
    if (isDesktop) {
      void navigate({ to: '/profile/details', replace: true });
    }
  }, [isDesktop, navigate]);

  if (isDesktop) {
    return null;
  }

  return <AccountMenu className="px-4 py-4" />;
}
